import React, { useEffect, useState } from 'react';
import { FaBars, FaStore, FaUtensils } from 'react-icons/fa';
import {
    ENTITY_TYPE_STORE,
    getBusinessLogoUrl,
    getEntityType,
} from './entityContext';
import {
    toggleRestaurantNav,
    BUSINESS_CONTEXT_CHANGED,
} from './restaurantNav';
import BusinessAccountMenu from './BusinessAccountMenu';
import '../admin/EatsAdminLayout.css';
import './css/Header.css';

const readBusinessName = () => {
    const isStore = getEntityType() === ENTITY_TYPE_STORE;
    if (isStore) {
        return localStorage.getItem('storeName') || 'Store';
    }
    return localStorage.getItem('restaurantName') || 'Restaurant';
};

const Header = () => {
    const [onDashboard, setOnDashboard] = useState(() =>
        typeof document !== 'undefined' &&
        document.documentElement.classList.contains('has-restaurant-dashboard')
    );
    const [businessName, setBusinessName] = useState(readBusinessName);
    const [logoUrl, setLogoUrl] = useState(getBusinessLogoUrl);
    const [isStore, setIsStore] = useState(() => getEntityType() === ENTITY_TYPE_STORE);

    useEffect(() => {
        const root = document.documentElement;
        const sync = () => {
            setOnDashboard(root.classList.contains('has-restaurant-dashboard'));
        };
        sync();
        const observer = new MutationObserver(sync);
        observer.observe(root, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const refresh = () => {
            setIsStore(getEntityType() === ENTITY_TYPE_STORE);
            setBusinessName(readBusinessName());
            setLogoUrl(getBusinessLogoUrl());
        };
        refresh();
        window.addEventListener(BUSINESS_CONTEXT_CHANGED, refresh);
        window.addEventListener('storage', refresh);
        return () => {
            window.removeEventListener(BUSINESS_CONTEXT_CHANGED, refresh);
            window.removeEventListener('storage', refresh);
        };
    }, []);

    const EntityIcon = isStore ? FaStore : FaUtensils;

    return (
        <header className={`restaurant-header${onDashboard ? ' restaurant-header--dashboard' : ''}`}>
            <button
                type="button"
                className="header-hamburger"
                onClick={toggleRestaurantNav}
                aria-label="Open navigation menu"
                aria-controls="restaurant-dashboard-sidebar"
            >
                <FaBars aria-hidden="true" />
            </button>
            <div className="jr-eatslogo-section header-business-brand" title={businessName}>
                {logoUrl ? (
                    <img
                        className="header-entity-logo"
                        src={logoUrl}
                        alt=""
                        onError={() => setLogoUrl('')}
                    />
                ) : (
                    <EntityIcon className="header-restaurant-icon" aria-hidden="true" />
                )}
                <span className="header-restaurant-name-text">{businessName}</span>
            </div>
            <div className="res-header-container1">
                {!onDashboard && <BusinessAccountMenu placement="header" />}
            </div>
        </header>
    );
};

export default Header;
